import { render, staticRenderFns } from "./my_drawer.vue?vue&type=template&id=83b24154&scoped=true&"
import script from "./my_drawer.vue?vue&type=script&lang=js&"
export * from "./my_drawer.vue?vue&type=script&lang=js&"
import style0 from "./my_drawer.vue?vue&type=style&index=0&id=83b24154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b24154",
  null
  
)

export default component.exports